import "./OpenLibraryHero.css";

/** Owner-supplied, decorative artwork. All interface copy stays selectable. */
export function OpenLibraryHero() {
  return (
    <section className="open-library-hero" aria-labelledby="open-library-heading" data-testid="open-library-hero">
      <picture className="open-library-hero__art">
        <source media="(max-width: 1023px)" srcSet="/open-library/open-library-hero-mobile.png" width="1080" height="394" />
        <img src="/open-library/open-library-hero-desktop.png" width="1536" height="561"
          alt="" fetchPriority="high" decoding="async" />
      </picture>
      <div className="open-library-hero__copy">
        <p className="open-library-hero__brand">ANOKINA STUDIO</p>
        <h1 id="open-library-heading" data-testid="library-title">Открытая библиотека</h1>
        <p className="open-library-hero__description">Живая коллекция рецептов, историй и ответов.</p>
        <p className="open-library-hero__signature">Знания вдохновляют<br />на новые десерты ♡</p>
      </div>
    </section>
  );
}
